import React from 'react'
import Chart from 'react-apexcharts'

const RateRadialChart = React.memo(({ rate, animationsEnabled, label, labelElement, getColor, ...props }) => {
    const defaultColor = '#212121'
    const hasCustomLabel = Boolean(labelElement)

    return (
      <div className={props.className} style={{ position: 'relative' }}>
          <Chart
            options={{
                chart: {
                    type: 'radialBar',
                    animations: {
                        enabled: animationsEnabled ?? false,
                        dynamicAnimation: {enabled: false}
                    },
                },
                colors: [getColor ? getColor(rate) : defaultColor],
                plotOptions: {
                    radialBar: {
                        startAngle: -90,
                        endAngle: 90,
                        track: {
                            strokeWidth: '97%',
                        },
                        hollow: {
                            size: '80%',
                        },
                        dataLabels: {
                            name: {
                                show: true,
                                fontSize: hasCustomLabel ? '1px' : '14px',
                                fontWeight: 'normal',
                                color: hasCustomLabel ? 'transparent' : '#333',
                                offsetY: 15,
                            },
                            value: {
                                fontSize: '26px',
                                color: getColor ? getColor(rate) : defaultColor,
                                offsetY: -30,
                                formatter: function (val) {
                                    return val + '%'
                                },
                            },
                        },
                    },
                },
                labels: [hasCustomLabel ? '' : (label ? label : '')],
            }}
            series={[rate]}
            type="radialBar"
            height={200}
          />
          {hasCustomLabel && (
            <div style={{
                position: 'absolute',
                top: '60%',
                left: 0,
                right: 0,
                display: 'flex',
                justifyContent: 'center',
                pointerEvents: 'auto',
            }}>
                {labelElement}
            </div>
          )}
      </div>
    )
})

export { RateRadialChart }
